import { BaseApi, HttpMethodEnum } from '../BaseApi/BaseApi';
import { IBatchDoseSuggestionRequest, IDoseSuggestionResult, IMMECalculationRequest, IMMECalculationResult, IOpioidDrugRouteCombination, ISaveMMECalculationRequest, ISavedMMECalculation, ITransdermalFentanylConfig } from '../../entities/MME/MME.ts';

export class MMEApi extends BaseApi {
    private static baseApiUrl: string = `${BaseApi.apiUrl}/MME`;

    public static apiUrls = {
        calculate: `${MMEApi.baseApiUrl}/Calculate`,
        getDrugRouteCombinations: `${MMEApi.baseApiUrl}/DrugRouteCombinations`,
        getAllDrugRouteCombinationsForAdmin: `${MMEApi.baseApiUrl}/DrugRouteCombinations/Admin`,
        save: `${MMEApi.baseApiUrl}/Save`,
        getSavedCalculations: `${MMEApi.baseApiUrl}/SavedCalculations`,
        deleteCalculation: `${MMEApi.baseApiUrl}/SavedCalculations`,
        getTransdermalFentanylConfig: `${MMEApi.baseApiUrl}/TransdermalFentanylConfig`,
        suggestDosesBatch: `${MMEApi.baseApiUrl}/SuggestDosesBatch`,
    };

    public static async calculateMME(request: IMMECalculationRequest): Promise<IMMECalculationResult> {
        return this.sendApiRequest<IMMECalculationResult>({
            method: HttpMethodEnum.POST,
            path:  this.apiUrls.calculate,
            data: request,
        });
    }

    public static async getDrugRouteCombinations(versionID?: number): Promise<IOpioidDrugRouteCombination[]> {
        const queryParams = versionID ? `?versionID=${versionID}` : '';
        return this.sendApiRequest<IOpioidDrugRouteCombination[]>({
            method: HttpMethodEnum.GET,
            path: `${this.apiUrls.getDrugRouteCombinations}${queryParams}`,
        });
    }

    public static async getAllDrugRouteCombinationsForAdmin(): Promise<IOpioidDrugRouteCombination[]> {
        return this.sendApiRequest<IOpioidDrugRouteCombination[]>({
            method: HttpMethodEnum.GET,
            path: this.apiUrls.getAllDrugRouteCombinationsForAdmin,
        });
    }

    public static async saveCalculation(request: ISaveMMECalculationRequest): Promise<number> {
        return this.sendApiRequest<number>({
            method: HttpMethodEnum.POST,
            path: this.apiUrls.save,
            data: request,
        });
    }

    public static async getSavedCalculations(patientID: number): Promise<ISavedMMECalculation[]> {
        return this.sendApiRequest<ISavedMMECalculation[]>({
            method: HttpMethodEnum.GET,
            path: `${this.apiUrls.getSavedCalculations}/${patientID}`,
        });
    }

    public static async deleteCalculation(calculationID: number): Promise<void> {
        return this.sendApiRequest<void>({
            method: HttpMethodEnum.DELETE,
            path: `${this.apiUrls.deleteCalculation}/${calculationID}`,
        });
    }

    public static async getTransdermalFentanylConfig(versionID?: number): Promise<ITransdermalFentanylConfig | null> {
        const queryParams = versionID ? `?versionID=${versionID}` : '';
        return this.sendApiRequest<ITransdermalFentanylConfig | null>({
            method: HttpMethodEnum.GET,
            path: `${this.apiUrls.getTransdermalFentanylConfig}${queryParams}`,
        });
    }

    public static async suggestDosesBatch(request: IBatchDoseSuggestionRequest): Promise<IDoseSuggestionResult[]> {
        return this.sendApiRequest<IDoseSuggestionResult[]>({
            method: HttpMethodEnum.POST,
            path: this.apiUrls.suggestDosesBatch,
            data: request,
        });
    }
}

